import React from "react";
import { Navigate } from "react-router-dom";


// Table Pages
import Projects from "../pages/Tabels/Projects/index";
import Phase from "../pages/Tabels/Phases/index";
import Block from "../pages/Tabels/Block/index";
import Client from "../pages/Client/List";
import Contract from "../pages/Contract/List";
import Invoice from "../pages/Invoice/index"
import SettelmentPrice from "../pages/Tabels/SettelmentPrice/index";
import Payment from "../pages/Tabels/Payment/index";
import Units from "../pages/Inventory/Unit/List";
import Users from "../pages/Tabels/Users/index";
import UserDetails from "../pages/Tabels/Users/UserDetails";
import Accounts from "../pages/AccountsSelection/index";
import AccountsDetails from "../pages/AccountsSelection/AccountsDetails"
import OverdueInvoice from "../pages/InvoicesOverdue/index"
import VendorInvoice from "../pages/VendorInvoices/index"
import VendorDetail from "../pages/VendorInvoices/VendorDetail"
import AdminOverview from "../pages/Admin/index"
import CostCategories from "../pages/Admin/CostCategories/index"

//Login
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Settings from "../pages/Pages/Profile/Settings/Settings";

//Reporting Pages
import ProjectReporting from "../pages/Reporting/ProjectReporting";
import RevenueBlockView from "../pages/Reporting/ProjectReporting/views/RevenueBlockView";

//Details
import SettlementDetails from "../pages/Tabels/SettelmentPrice/SettlementDetails";
import ProjectDetails from "../pages/Tabels/Projects/UnitDetails";
import BlockDetail from "../pages/Tabels/Block/BlockDetail";
import PhaseDetail from "../pages/Tabels/Phases/PhaseDetail";
import UnitDetail from "../pages/Inventory/Unit/Detail";
import ContractDetail from "../pages/Contract/ContractDetail/index";
import ClientDetail from "../pages/Client/ClientDetails/index";
import PaymentDetails from "../pages/Tabels/Payment/PaymentDetails";

const authProtectedRoutes = [
  //Tabels
  { path: "/projects", component: <Projects /> },
  { path: "/phases", component: <Phase /> },
  { path: "/blocks", component: <Block /> },
  // { path: "/table-unit", component: <Unit /> },
  // { path: "/financial",  }
  { path: "/financial/contracts", component: <Contract /> },
  { path: "/financial/invoices", component: <Invoice /> },
  { path: "/financial/invoices/overdue", component: <OverdueInvoice /> },
  { path: "/financial/invoices/vendors", component: <VendorInvoice /> },
  { path: "/financial/invoices/vendors/:cif", component: <VendorDetail /> },
  { path: "/financial/clients", component: <Client /> },
  { path: "/table-settlement-price", component: <SettelmentPrice /> },
  // { path: "/table-payment", component: <Payment /> },
  { path: "/admin/panel", component: <AdminOverview /> },
  { path: "/admin/panel/cost-categories", component: <CostCategories /> },
  { path: "/admin/panel/users", component: <Users /> },
  { path: "/admin/panel/users/:id", component: <UserDetails /> },
  { path: "/admin/panel/accounts", component: <Accounts /> },
  { path: "/admin/panel/accounts/add-accounts", component: <AccountsDetails /> },
  { path: "/admin/panel/accounts/:id", component: <AccountsDetails /> },
  { path: "/units-by-block/:blockId", component: <Units /> },

  //Reporting
  { path: "/project-reporting/:projectId/overview", component: <ProjectReporting /> },
  { path: "/project-reporting/:projectId/budget", component: <ProjectReporting /> },
  { path: "/project-reporting/:projectId/revenue", component: <ProjectReporting /> },
  { path: "/project-reporting/:projectId/revenue/phase/:phaseId/block/:blockId", component: <RevenueBlockView /> },

  //Details Pages
  { path: "/settlement-details/:id", component: <SettlementDetails /> },
  { path: "/project-details/:id", component: <ProjectDetails /> },
  { path: "/block-details/:id", component: <BlockDetail /> },
  { path: "/phase-details/:id", component: <PhaseDetail /> },
  { path: "/unit-details/:id", component: <UnitDetail /> },
  { path: "/financial/contracts/:id", component: <ContractDetail /> },
  { path: "/client-details/:id", component: <ClientDetail /> },
  { path: "/payment-details/:id", component: <PaymentDetails /> },

  //Pages
  { path: "/pages-profile-settings", component: <Settings /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/financial/contracts" />,
  },
  { path: "*", component: <Navigate to="/financial/contracts" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
];

export { authProtectedRoutes, publicRoutes };
